var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodata(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2000 2000",
    width: 1280,
    height: 1280,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h2e3v2e3h-2e3z",
    fill: "#fbfcef"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(330,616)",
    d: "m0 0h837l13 4 9 6 7 7 6 10 3 14 26 312 1 10 12 25 30 60 12 26 3 14v13l-3 14-8 16-9 11-12 9-8 4h-2l1 3 3 35v17l-4 11-7 9-9 6-9 3h-841l-12-4-9-6-8-9-5-10-2-8-13-155-12-144-20-241-1-10v-24l4-10 7-9 9-6z",
    fill: "#fbfcef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1452,369)",
    d: "m0 0h10l6 4 4 6v11l14 2 8 3 7 6 1 2v11l-5 13-6 12-4 7-1 4v35l-4 11-3 3v36l10 1 5 4v8h11l33 4 11 3 8 6 9 9 8 13 8 17 5 15 3 12v5l-7 4 3 12 14 49 6 26 1 7v12l-4 20-8 22-12 25-12 20-3 4-2 10-9 12-11 11-9 7 1 23 18 218 6 68 8 57 14 80 16 83 17 84 11 52v2h4l4 16-1 4-13 2 9 30v3h5l12 27v5l-4 3-38 8-38 10-8-1-5-6 1-6 15-8 12-9 8-8 3-5 6-3-2-10-7-22-13 2-6 1-8-16-1-5 1-1h5l-7-23-30-105-23-83-22-83-13-53-9-43-9-57-3-22-4 48-5 78-8 160-8 170-2 33h6l-2 20h-16l1 3v35h5l2 6 4 22-1 7-2 1h-99l-5-3-3-3-1-6 3-3 31-7 13-5 16-8 5-1v-38h-19l-2-14v-9l8 1-1-5-9-144-7-128-3-70-1-34v-52l2-68 5-115 6-115v-15l-4-50-2-37v-86l1-18-16-4 4-23-27-6-20-7-12-6-7-8-2-7 1-10 6-9 9-10 10-9 16-12 24-16 25-15 18-10 2-8-2-8-2-6 2-3v-11l-4-1 5-5 2-10h-15l-6-3-4-4-1-3v-11l3-9v-6l-3-6 1-8 6-5 2-1h11l5 3 7 8 8 4 11 1 12-3 12-6 12-9z",
    fill: "#C6FF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(330,616)",
    d: "m0 0h837l13 4 9 6 7 7 6 10 3 14 26 312 1 10 12 25 30 60 12 26 3 14v13l-3 14-8 16-9 11-12 9-8 4h-2l1 3 3 35v17l-4 11-7 9-9 6-9 3h-841l-12-4-9-6-8-9-5-10-2-8-13-155-12-144-20-241-1-10v-24l4-10 7-9 9-6zm-28 40 1 19 45 541 4 13 6 9 9 8 11 5 5 1h836l10-3 9-6 6-8 3-7 1-5v-11l-3-36-2-4-9 2h-20l-159-21-210-28-13-3-14-7-11-9-9-13-5-11-3-13v-15l4-16 7-14 13-18 8-12 13-19 14-20 11-16 13-19 11-16 13-19 16-23 15-22 11-16 12-17 8-12 11-16 12-17 15-22 10-14 10-9 10-6 11-4 12-2h10l12 2 13 5 11 7 5 4 9 12 39 78 11 23 30 60 11 23 25 50h1l-1-21-24-288-1-4z",
    fill: "#fbfcef"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1452,369)",
    d: "m0 0h10l6 4 4 6v11l14 2 8 3 7 6 1 2v11l-5 13-6 12-4 7-1 4v35l-4 11-3 3v36l10 1 5 4v8h11l33 4 11 3 8 6 9 9 8 13 8 17 5 15 3 12v5l-19 10-31 16 2 9 16 47 6 20v17l-5 23-9 29-9 25-9 3-166-1-3-1-2-17-4-55-1-21v-86l1-18-16-4 4-23-27-6-20-7-12-6-7-8-2-7 1-10 6-9 9-10 10-9 16-12 24-16 25-15 18-10 2-8-2-8-2-6 2-3v-11l-4-1 5-5 2-10h-15l-6-3-4-4-1-3v-11l3-9v-6l-3-6 1-8 6-5 2-1h11l5 3 7 8 8 4 11 1 12-3 12-6 12-9z",
    fill: "#FF9100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(330,616)",
    d: "m0 0h837l13 4 9 6 7 7 6 10 3 14 26 312 1 10 12 25 30 60 12 26 3 14v13l-3 14-8 16-9 11-12 9-8 4h-2l1 3 3 35v17l-4 11-7 9-9 6-9 3h-841l-12-4-9-6-8-9-5-10-2-8-13-155-12-144-20-241-1-10v-24l4-10 7-9 9-6zm-28 40 1 19 45 541 4 13 6 9 9 8 11 5 5 1h836l10-3 9-6 6-8 3-7 1-5v-11l-3-36-2-4-9 2h-20l-159-21-210-28-13-3-14-7-11-9-9-13-5-11-3-13v-15l4-16 7-14 13-18 8-12 13-19 14-20 11-16 13-19 11-16 13-19 16-23 15-22 11-16 12-17 8-12 11-16 12-17 15-22 10-14 10-9 10-6 11-4 12-2h10l12 2 13 5 11 7 5 4 9 12 39 78 11 23 30 60 11 23 25 50h1l-1-21-24-288-1-4zm748 76-10 3-8 5-8 9-10 15-16 23-15 22-16 23-17 25-14 20-15 22-13 19-14 20-15 22-16 23-17 25-16 23-9 14-2 6v16l4 11 6 8 7 7 10 5 16 3 361 48h14l11-4 10-9 5-9 2-13-2-11-11-23-23-47-26-52-11-23-31-62-11-23-30-60-11-23-19-38-7-9-10-7-13-4z",
    fill: "#FF9100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(557,748)",
    d: "m0 0h13l10 3 9 6 19 19 7 8 12 12 7 8 11 11 7 8 12 12 7 8 11 11 7 8 11 11 7 8 12 12 7 8 11 11 7 8 9 9 6 10 3 12-1 13-4 10-6 8-7 6-8 4-90 18-113 22-22 4-12-1-10-4-9-7-6-8-4-10-1-5v-8l5-21 27-103 22-83 5-16 6-9 9-8 10-4z",
    fill: "#fbfcef"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1452,369)",
    d: "m0 0h10l6 4 4 6v11l14 2 8 3 7 6 1 2v11l-5 13-6 12-4 7-1 4v35l-4 11-3 3v36l10 1 5 4v7h-48l-22 1-16 1 3-6 5-4 10-3h5l2-10v-4l-12-2-10-5-9-8-9 6-16 13-9 7-11 9-13 11-3 4 13 1-1 10-7 36-11-1-20-5-19-7-10-5-7-8-2-7 1-10 6-9 9-10 10-9 16-12 24-16 25-15 18-10 2-8-2-8-2-6 2-3v-11l-4-1 5-5 2-10h-15l-6-3-4-4-1-3v-11l3-9v-6l-3-6 1-8 6-5 2-1h11l5 3 7 8 8 4 11 1 12-3 12-6 12-9z",
    fill: "#903C39"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(557,748)",
    d: "m0 0h13l10 3 9 6 19 19 7 8 12 12 7 8 11 11 7 8 12 12 7 8 11 11 7 8 11 11 7 8 12 12 7 8 11 11 7 8 9 9 6 10 3 12-1 13-4 10-6 8-7 6-8 4-90 18-113 22-22 4-12-1-10-4-9-7-6-8-4-10-1-5v-8l5-21 27-103 22-83 5-16 6-9 9-8 10-4zm2 15-8 3-7 8-6 21-26 99-18 68-7 26v12l4 8 7 7 7 3h12l215-42 8-4 4-5 3-7v-8l-4-10-14-15-8-8-7-8-12-12-7-8-11-11-7-8-11-11-7-8-12-12-7-8-7-7-7-8-16-16-7-8-11-11-7-8-8-8-10-4z",
    fill: "#FF9100"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1034,836)",
    d: "m0 0h11l26 4 10 5 7 8 4 9v22l-1 19-17 94-4 10-9 8-6 2h-13l-9-4-8-7-4-6-2-6-7-96v-14l2-30 4-8 8-7z",
    fill: "#FF9100"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1452,369)",
    d: "m0 0h10l6 4 4 6v11l14 2 8 3 7 6 1 2v11l-5 13-6 12-4 7-1 4v35l-4 11-5 4-5 2h-10l-14-3-1-2 12-6 2-2 2-13v-12l-2-3-3-1h-9l-13 3-19 1-2-16-5-5-5 1-3 6h-2l-2-6v-15l1-3-10 2h-15l-6-3-4-4-1-3v-11l3-9v-6l-3-6 1-8 6-5 2-1h11l5 3 7 8 8 4 11 1 12-3 12-6 12-9z",
    fill: "#1B2E36"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1581,636)",
    d: "m0 0 2 2 14 48 8 32 2 12v12l-4 20-8 22-12 25-12 20-3 4-2 10-9 12-11 11-9 7-2-1-3-41 8-3 10-28 8-26 5-23v-17l-9-29-15-44 1-4 22-11z",
    fill: "#903B38"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1362,1568)",
    d: "m0 0 54 2 16 1-2 20h-16l1 3v35h5l2 6 4 22-1 7-2 1h-99l-5-3-3-3-1-6 3-3 31-7 13-5 16-8 5-1v-38h-19l-2-14z",
    fill: "#1B2F37"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1627,1540)",
    d: "m0 0h5l4 16-1 4-13 2 9 30v3h5l12 27v5l-4 3-38 8-38 10-8-1-5-6 1-6 15-8 12-9 8-8 3-5 6-3-2-10-7-22-13 2-6 1-8-16-1-5 7-2z",
    fill: "#1B2F38"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,825)",
    d: "m0 0h11l7 4 4 5 5 16 3 14 7 47v13l-4 6-5 3h-11l-6-3-5-6-12-29-12-30-5-19v-7l4-8 5-3z",
    fill: "#FF9100"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1536,659)",
    d: "m0 0h3l10 28 13 40 2 7v17l-5 23-9 29-9 25-9 3v-120l2-36z",
    fill: "#fbfcef"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1034,1042)",
    d: "m0 0 14 1 9 3 9 8 4 9v14l-5 8-6 5-5 2h-13l-9-2-8-5-6-7-3-8v-11l5-10 7-5z",
    fill: "#FF9100"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1401,506)",
    d: "m0 0 7 6 8 5 9 3 8 1 1 5-3 10-15 4-5 4-3 5-5 1-48 3v5l-14-1 2-4 11-10 14-11 12-10 16-12z",
    fill: "#fbfcef"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1627,1540)",
    d: "m0 0h5l4 16-1 4-37 8h-6l-1 2-13 2-6 1-8-16-1-5 7-2z",
    fill: "#1B2F37"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1362,1568)",
    d: "m0 0 54 2 16 1-2 20h-66l-2-14z",
    fill: "#1A2E36"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1383,1591)",
    d: "m0 0h31l1 3v35h-32z",
    fill: "#913C39"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1621,1562)",
    d: "m0 0 2 3 8 27-1 4-25 6h-4l-9-29v-5z",
    fill: "#913C39"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1446,534)",
    d: "m0 0h27l16 2 5 4v7h-48l-22 1-16 1 3-6 5-4 10-3z",
    fill: "#1B2E36"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(609,948)",
    d: "m0 0h10l7 4 4 7v9l-3 5-5 4-5 1h-8l-6-3-5-6-1-3v-8l3-5 5-4z",
    fill: "#FF9100"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(299,776)",
    d: "m0 0h3l7 81 2 29-4-1-9-108z",
    fill: "#FF9100"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1358,632)",
    d: "m0 0 10 1 32 1-2 2-19 5-13 2h-9v-9z",
    fill: "#0055B7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(378,628)",
    d: "m0 0 6 1 4 4 1 6-3 5-1 1h-8l-5-5v-7l3-4z",
    fill: "#FAFAFA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(412,628)",
    d: "m0 0 7 2 3 4v7l-4 4h-8l-4-4-1-7 4-5z",
    fill: "#FAFAFA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(345,628)",
    d: "m0 0 7 2 3 5-1 7-3 3h-8l-5-6 1-7 3-3z",
    fill: "#FAFAFA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1584,1594)",
    d: "m0 0h5l6 8 1 3h-2l-2 5-4 1h-8l-2-2v-5l7-2-2-3z",
    fill: "#037CFC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1369,1618)",
    d: "m0 0 5 1 4 8v4l-10 5-7-3-1-5 2-2 6 1 2 1-3-5 1-4z",
    fill: "#007AFC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(310,914)",
    d: "m0 0h3l1 3 2 23v9h-3l-1-2-2-23z",
    fill: "#FF9100"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1538,640)",
    d: "m0 0 3 4 5 11-7 4h-3l1-14z",
    fill: "#0056B9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1580,1605)",
    d: "m0 0h7l5 2-3 2-7 1-3-3z",
    fill: "#FAFAFA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1362,1628)",
    d: "m0 0 7 1 4 2v2l-5 1-5-2z",
    fill: "#FAFAFA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1369,1620)",
    d: "m0 0 4 1 3 6-1 3-6-7z",
    fill: "#FAFAFA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1584,1596)",
    d: "m0 0 5 1 4 5-1 3-7-6z",
    fill: "#FAFAFA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1580,1603)",
    d: "m0 0m-2 1h2v5l12-1-1 3h-11l-2-2z",
    fill: "#007AFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodata);
export default __webpack_public_path__ + "static/media/nodata.e3422d9b1ec19af1cba7f17211317863.svg";
export { ForwardRef as ReactComponent };